var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74661 3.23535C2.29726 3.23535 2.07598 3.78198 2.3988 4.09456L12.4254 13.803C12.6125 13.9842 12.9073 13.9914 13.1031 13.8196L21.6873 6.285L20.4466 18.3193C20.4203 18.5742 20.2055 18.768 19.9492 18.768L5.75457 18.7684C5.47843 18.7684 5.25458 18.9922 5.25458 19.2684V20.2684C5.25458 20.5445 5.47844 20.7684 5.75458 20.7684H21.7532C22.0095 20.7684 22.2242 20.5746 22.2505 20.3197L23.9557 3.78665C23.9861 3.49178 23.7547 3.23535 23.4583 3.23535H2.74661ZM19.1874 5.235C19.4181 5.235 19.5257 5.52077 19.3523 5.67291L13.1688 11.099C12.9731 11.2707 12.6783 11.2635 12.4912 11.0824L6.89601 5.6646C6.7346 5.50831 6.84524 5.235 7.06991 5.235H19.1874Z",
    fill: "#0052D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00049,
    y: 8.19995,
    width: 6.6664,
    height: 2,
    rx: 0.5,
    fill: "#0052D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000488281 12.7C0.000488281 12.4238 0.224346 12.2 0.500488 12.2H9.31423C9.59037 12.2 9.81423 12.4238 9.81423 12.7V13.7C9.81423 13.9761 9.59037 14.2 9.31423 14.2H0.500488C0.224346 14.2 0.000488281 13.9761 0.000488281 13.7V12.7Z",
    fill: "#0052D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50049 15.8999C2.50049 15.6238 2.72435 15.3999 3.00049 15.3999H11.5005C11.7766 15.3999 12.0005 15.6238 12.0005 15.8999V16.8999C12.0005 17.176 11.7766 17.3999 11.5005 17.3999H3.00049C2.72435 17.3999 2.50049 17.176 2.50049 16.8999V15.8999Z",
    fill: "#0052D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadCase);
export default __webpack_public_path__ + "static/media/bad-case.6de8eeacfe0832d81ea099a9f20523fe.svg";
export { ForwardRef as ReactComponent };